import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ShipperOrderTableRow from 'modules/shipper-order/Table/ShipperOrderTableRow';

const ShipperOrderTable = ({ ids, onRowClick }) => {
  return (
    <Fragment>
      {ids.map((id) => (
        <ShipperOrderTableRow itemId={id} key={id} onClick={onRowClick} />
      ))}
    </Fragment>
  );
};

ShipperOrderTable.propTypes = {
  ids: PropTypes.array,
  onRowClick: PropTypes.func,
};

export default ShipperOrderTable;
